module.exports = require('./helpers/bundle-url').getBundleURL('a5wOv') + "logo-dark.eefe0b7f.svg";